const { commonConfig } = require('@alfa-bank/assr-common-config');
const { cdnPlugin } = require('@plotva/assr-core-plugins');
const { name, version, dependencies } = require('./package.json');

const config = {
    ...commonConfig,
    postcss: {
        customPropertiesFile: 'node_modules/@alfalab/core-components-themes/site.css'
    },
    cssHashLen: 4,
    widgetsContexts: ['@alfa-bank', '@plotva'],
    additionalWidgetPackages: [],
    instanceName: name,
    instanceVersion: version,
    getDependencies: () => dependencies,
    cdnReplacement: {
        enabled: true, // Включить замену домена на cdn
        viewLog: false,
    },
    plugins: [{
        plugin: cdnPlugin,

        config: {
            cdnPublicPath: process.env.CDN_PUBLIC_PATH,
            domainPattern: '(https?:)?//alfabank[.]st'
        }
    }]
};

module.exports = config; 
